import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { androidAppLink, appleAppLink } from '../../../marketplace-links';
import { isCordova } from '../../../util/mobile/deviceDetection';
import BoxSeparator from '../../BoxSeperator/BoxSeparator';
import IconArrowUpRight from '../../Icons/IconArrowUpRight';

const buttonLinkStyle = { justifyContent: 'space-between' };

const SectionAppComponent = () => {
  if (isCordova()) {
    return null;
  }

  return (
    <>
      <BoxSeparator />
      <Stack px={4}>
        <Typography gutterBottom variant="h5">
          <FormattedMessage id="AccountBottomBarBox.appHeader" />
        </Typography>

        <Button
          color="secondary"
          href={appleAppLink}
          rel="noreferrer"
          sx={buttonLinkStyle}
          target={isCordova() ? '_self' : '_blank'}
        >
          <FormattedMessage id="AccountBottomBarBox.appiOS" />
          <IconArrowUpRight />
        </Button>
        <Button
          color="secondary"
          href={androidAppLink}
          rel="noreferrer"
          sx={buttonLinkStyle}
          target={isCordova() ? '_self' : '_blank'}
        >
          <FormattedMessage id="AccountBottomBarBox.appAndroid" />
          <IconArrowUpRight />
        </Button>
      </Stack>
    </>
  );
};

SectionAppComponent.displayName = 'SectionApp';
const SectionApp = memo(SectionAppComponent);

export default SectionApp;
